/**
 * Name pattern — same as Angular UserManagementAddComponent:
 * - No leading/trailing spaces
 * - Up to 2 internal spaces (max 3 words)
 * - Allows alphanumeric and special characters
 */
export const NAME_PATTERN =
  /^(?! )[a-zA-Z0-9!@#$%^&*()_+=[\]{}|;:'",.<>?/`~\\-]+(?: [a-zA-Z0-9!@#$%^&*()_+=[\]{}|;:'",.<>?/`~\\-]+){0,2}(?<! )$/

/** Email regex matching Angular Validators.email */
export const EMAIL_REGEX =
  /^(?=.{1,254}$)(?=.{1,64}@)[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/

/**
 * Mirrors Angular `customvalidation.mobileValidator`.
 * Strips non-digits then tests the pattern.
 */
export function validateMobile(value: string): boolean {
  const mobile = String(value ?? '').replace(/\D/g, '')
  return /^([+]?\d{1,2}[.-\s]?)?(\d{3})(\d{3})(\d{4})$/.test(mobile)
}

export function validateEmail(value: string): boolean {
  return EMAIL_REGEX.test(value.trim())
}

export function validateName(value: string): boolean {
  return NAME_PATTERN.test(value)
}

/**
 * `alreadyLinkedEmail` validator logic.
 * Returns true (valid) if email is NOT in the rejected list.
 */
export function isEmailNotLinked(email: string, rejectedEmails: string[]): boolean {
  return !rejectedEmails.includes(email.trim().toLowerCase())
}
